<template></template>

<script>
import { auth, db, messaging } from "@/firebase";
import { getToken } from "firebase/messaging";
import { collection, query, where, getDocs, limit, doc, setDoc, serverTimestamp, orderBy } from "firebase/firestore";
export default {
    name: "GoodBzzNotificacionesPush",

    async created() {
        let usuario = auth.currentUser;
        if (usuario) {
            let usuarioDB = await this.$store.state.obtenerUsuario(usuario.uid);
            if (usuarioDB) {
                await this.verificarSuscripcion(usuarioDB.id);
            }
        }
    },

    methods: {
        async crearSuscripcion(idUsuario, token) {
            const refSuscripcion = doc(collection(db, "suscripciones"));
            await setDoc(doc(db, "suscripciones", refSuscripcion.id), {
                id: refSuscripcion.id,
                idUsuario: idUsuario,
                token: token,
                temas: [
                    "Comunidad",
                    "Noticias",
                    "Publicidad",
                    "ActualizacionesApp"
                ],
                registro: {
                    creacion: serverTimestamp(),
                    actualizacion: serverTimestamp(),
                }
            });
        },

        async obtenerSuscripcion(idUsuario) {
            let suscripcion = null;
            const q = query(collection(db, "suscripciones"), where("idUsuario", "==", idUsuario), orderBy("registro.creacion", "desc"), limit(1));
            const querySnapshot = await getDocs(q);
            querySnapshot.forEach((doc) => {
                suscripcion = doc.data()
            });
            return suscripcion;
        },

        async verificarSuscripcion(idUsuario) {
            getToken(messaging, { vapidKey: "BOY1MB9OumZrXVOnlztGg3Pejh608LImsn75gZpsDZO8naNK5_ch5vr-6qEWf_nDRJWGOMDPShIMmbDNruYvut4" }).then((token) => {
                if (token) {
                    (async () => {
                        let obtenerSuscripcion = await this.obtenerSuscripcion(idUsuario);
                        if (!obtenerSuscripcion) {
                            await this.crearSuscripcion(idUsuario, token);
                        }
                    })();
                } else {
                    this.solicitarPermiso()
                }
            }).catch((err) => {
            });
        },

        async solicitarPermiso() {
            Notification.requestPermission().then((permission) => {
                if (permission === 'granted') {
                    this.verificarSuscripcion();
                } else {
                    console.log('No se ha aceptado el permiso para recibir notificaciones.');
                }
            });
        }
    }
}
</script>

<style scoped>

</style>